// source: inv_view_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.View.v1.View', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.View.v1.View, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.View.v1.View.displayName = 'proto.Olameter.WFMS.InventoryManagement.View.v1.View';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.View.v1.View.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.toObject = function(includeInstance, msg) {
  var f, obj = {
userName: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
contractName: jspb.Message.getFieldWithDefault(msg, 4, ""),
contractTitle: jspb.Message.getFieldWithDefault(msg, 5, ""),
gridState: jspb.Message.getFieldWithDefault(msg, 6, ""),
active: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
isDefault: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
lastSeen: (f = msg.getLastSeen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.View.v1.View;
  return proto.Olameter.WFMS.InventoryManagement.View.v1.View.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractTitle(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGridState(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDefault(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSeen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.View.v1.View.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContractTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGridState();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getIsDefault();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getLastSeen();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string contract_name = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string contract_title = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getContractTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setContractTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string grid_state = 6;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getGridState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setGridState = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool active = 7;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool is_default = 8;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getIsDefault = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setIsDefault = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp last_seen = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.getLastSeen = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
*/
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.setLastSeen = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.View.v1.View} returns this
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.clearLastSeen = function() {
  return this.setLastSeen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.View.v1.View.prototype.hasLastSeen = function() {
  return jspb.Message.getField(this, 9) != null;
};


goog.object.extend(exports, proto.Olameter.WFMS.InventoryManagement.View.v1);
